import { partnerActions } from "./PartnerReducer";
import { usePartnerAPI  } from '../../../api/partner/usePartnerAPI';

export const usePartner = () => {
    const api = usePartnerAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.partner.get(params);
              dispatch(partnerActions.funGetPartner(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.partner.post(data);
        },
        put: async (data) => {
          return await api.partner.put(data);
        },
        delete: async (params) => {
          return await api.partner.delete(params);
        }
    };
    return { request };
  };